import { Recipe } from '@akin-home/amplify';
import { postImageToCloud } from '@akin-home/images/frontend';
import { Recipe as RecipeModel } from '@akin-home/recipes';
import { updateRecipeMutation } from '../api/mutations';
import { recipeModelToUpdateRecipeInput } from './index';

export const updateRecipeFromModel = async (
  recipe: RecipeModel
): Promise<Recipe> => {
  const recipeToPost = {
    ...recipe,
  };

  if (recipeToPost.imageUpload) {
    recipeToPost.image = await postImageToCloud({
      habitatID: recipeToPost.habitatID as string,
      readGroups: recipeToPost.habitatID ? undefined : ['common'],
      file: recipeToPost.imageUpload,
    });
  }
  const input = recipeModelToUpdateRecipeInput(recipeToPost);

  const res = await updateRecipeMutation({
    input,
  });

  return res.data.updateRecipe as Recipe;
};
